export let GroupNotificationKind = /*#__PURE__*/function (GroupNotificationKind) {
  GroupNotificationKind["UNKNOWN_GROUP_NOTIFICATION_KIND"] = "UNKNOWN_GROUP_NOTIFICATION_KIND";
  GroupNotificationKind["GROUP_READY"] = "GROUP_READY";
  GroupNotificationKind["GROUP_CREATE_FAILED"] = "GROUP_CREATE_FAILED";
  return GroupNotificationKind;
}({});
export let WhatsappGroupStatus = /*#__PURE__*/function (WhatsappGroupStatus) {
  WhatsappGroupStatus["UNKNOWN_WHATSAPP_GROUP_STATUS"] = "UNKNOWN_WHATSAPP_GROUP_STATUS";
  WhatsappGroupStatus["PENDING_CREATE"] = "PENDING_CREATE";
  WhatsappGroupStatus["ACTIVE"] = "ACTIVE";
  WhatsappGroupStatus["OWNER_LEFT"] = "OWNER_LEFT";
  WhatsappGroupStatus["DELETED"] = "DELETED";
  WhatsappGroupStatus["CREATE_FAILED"] = "CREATE_FAILED";
  return WhatsappGroupStatus;
}({});
export let WhatsappGroupResponseMode = /*#__PURE__*/function (WhatsappGroupResponseMode) {
  WhatsappGroupResponseMode["UNKNOWN_WHATSAPP_GROUP_RESPONSE_MODE"] = "UNKNOWN_WHATSAPP_GROUP_RESPONSE_MODE";
  WhatsappGroupResponseMode["MENTION_ONLY"] = "MENTION_ONLY";
  WhatsappGroupResponseMode["ALWAYS"] = "ALWAYS";
  return WhatsappGroupResponseMode;
}({});
export let SortOrder = /*#__PURE__*/function (SortOrder) {
  SortOrder["ASC"] = "ASC";
  SortOrder["DESC"] = "DESC";
  return SortOrder;
}({});
//# sourceMappingURL=types.js.map